"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatResponse = exports.prepareRequest = exports.getBasicHeaders = void 0;
// biome-ignore lint/style/useNodejsImportProtocol: needs to be polyfill by client apps
const events_1 = require("events");
const query_string_1 = __importDefault(require("query-string"));
const auth_1 = __importDefault(require("@themenu/auth"));
const crypto_1 = require("./crypto");
const locale_1 = require("./locale");
const errorEmitter = new events_1.EventEmitter();
// TODO: see how not to use process.env here
const API_SECRET = process.env.REACT_APP_API_SECRET;
const PLATFORM = 'web';
const VERSION = process.env.REACT_APP_SOURCE_VERSION;
const API_KEY = (0, crypto_1.generateApiKey)({ version: VERSION, platform: PLATFORM, apiSecret: API_SECRET });
const getBasicHeaders = () => {
    return {
        'X-Lunchr-Platform': PLATFORM,
        'X-Lunchr-App-Version': VERSION,
        'X-API-Key': API_KEY,
        'Accept-Language': (0, locale_1.detectBrowserLocale)(),
    };
};
exports.getBasicHeaders = getBasicHeaders;
const parseStringAsJson = (body) => {
    try {
        return body.length > 0 && !body.startsWith('<') ? JSON.parse(body) : {};
    }
    catch (error) {
        console.error(error);
        return {};
    }
};
const isRecord = (obj) => {
    if (typeof obj !== 'object') {
        return false;
    }
    if (obj instanceof FormData) {
        return false;
    }
    if (obj instanceof Blob) {
        return false;
    }
    if (Array.isArray(obj)) {
        return false;
    }
    if (Object.getOwnPropertySymbols(obj).length > 0) {
        return false;
    }
    return true;
};
const getRequestHeaders = ({ headers, contentType = 'application/json', }) => {
    const requestHeaders = JSON.parse(JSON.stringify({
        ...(0, exports.getBasicHeaders)(),
        ...headers,
        ...(contentType && { 'Content-Type': contentType }),
    }));
    auth_1.default.readCookies();
    if ('authorization' in requestHeaders) {
        if (!requestHeaders.authorization) {
            requestHeaders.authorization = undefined;
        }
    }
    else if (auth_1.default.token) {
        requestHeaders.authorization = `Bearer ${auth_1.default.token}`;
    }
    return requestHeaders;
};
const prepareRequest = ({ method, endpoint, serviceUrl, body, headers, options, }) => {
    const { encode, rawRequest, ...fetchOptions } = options;
    let url = `${serviceUrl}/${endpoint}`;
    const requestHeaders = getRequestHeaders({ headers, contentType: rawRequest ? false : 'application/json' });
    let init = {
        method,
        headers: requestHeaders,
        ...fetchOptions,
    };
    if (method === 'GET') {
        if (body) {
            if (isRecord(body)) {
                const queryStringFormatted = query_string_1.default.stringify(body, { encode });
                if (queryStringFormatted) {
                    url += `?${queryStringFormatted}`;
                }
            }
            else {
                console.warn(`${body} is not an object`);
            }
        }
    }
    else {
        init = {
            ...init,
            body: rawRequest && (body instanceof FormData || body instanceof Blob) ? body : JSON.stringify(body),
        };
    }
    return { url, init };
};
exports.prepareRequest = prepareRequest;
const formatResponse = async ({ response, withStatusCode = false, rawResponse = false, }) => {
    if (rawResponse && response.ok) {
        if (withStatusCode) {
            return Promise.resolve({ httpStatus: response.status, ...response });
        }
        return Promise.resolve(response);
    }
    return response.text().then((txt) => {
        const data = parseStringAsJson(txt);
        if (response.ok) {
            if (withStatusCode) {
                return { httpStatus: response.status, ...data };
            }
            return data;
        }
        errorEmitter.emit('request:error', response.status, { ...data });
        return Promise.reject({ status: response.status, ...data });
    });
};
exports.formatResponse = formatResponse;
//# sourceMappingURL=request.js.map